import React, { Component } from 'react'
import Settings from '../settings'

// This component:
// 1. contains navigation - left and right
// 2. enables animated scrolling to each section

// Import animation libraries
import { TimelineMax, Quart } from 'TweenMax'
import 'ScrollToPlugin'

class Navigation extends Component {

   constructor() {
      super()
      this.state = {
         toggle: 0
      }
   }

   componentDidMount() {
      document.addEventListener( 'keydown', this.keydown.bind(this) )
   }

   keydown = (e) => {
      const keys = {
         27: this.close // escape
      }
      if (e.keyCode in keys) keys[e.keyCode]()
   }

   // renderSpacer = (link,i) => <span className="navigation__spacer">|</span>
   scrollTo = (e, url) => {
      if (
         Settings.animation.scrollTo
         && url.includes('#')
         && !url.includes('/#')
         && document.querySelector(url)
      ) {
         e.preventDefault()
         new TimelineMax().to(window, 0, {scrollTo: url, ease: Quart.easeInOut }) // 0.75
         this.setState({toggle: 0})
      }
   }

   toggle = (e) => {
      e.preventDefault()
      this.setState({toggle: !this.state.toggle })
   }

   open = () => {
      this.setState({toggle: 0})
   }

   close = () => {
      this.setState({toggle: 0})
   }

   renderLink = (link,i) => {
       const url = (link.url.includes('#') && !link.url.includes('/#')) ? '/'+link.url : link.url
       return (
         <div key={i} className="navigation__link">
            <a href={ url } target={link.target || ''} onClick={(e) => this.scrollTo(e, link.url)}>
               <span>{link.title}</span>
            </a>
         </div>
       )
   }

   render() {
      const {
        navigation = [
          {title:'Home',url: Settings.origin+'/'},
          {title:'About',url: Settings.origin+'/#about'},
          {title:'Events',url: Settings.origin+'/#events'},
         //  {title:'Event Calendar',url: Settings.origin+'/#event-calendar'},
          {title:'Biographies',url: Settings.origin+'/#biographies'},
          {title:'Supporters',url: Settings.origin+'/#supporters'},
          // {title:'Back to Top',url: Settings.origin+'/#top'},
        ]
      } = this.props.data

      const openClass = (this.state.toggle) ? 'navigation-open' : 'navigation-closed'

      return (
         <div className={`Navigation ${openClass}`}>

            <div className="page-width">

               <a className="navigation-icon-link" alt="Navigation" href="#top" onClick={(e) => this.toggle(e)}><div className="navigation-icon"></div></a>
               <div className={ `navigation-expanded vertical-align`} onClick={(e) => this.close()}>
                  <div className="navigation-links">
                  { navigation.map((link,i) => this.renderLink(link,i) ) }
                  </div>
               </div>

            </div>

         </div>
      )
   }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation.js